import DynamicSectionElement from '@/scripts/dynamic-section-element.js'
import {  clearAllBodyScrollLocks } from 'body-scroll-lock'
import Cookies from 'cookies-js'

const COOKIE_NAME = 'dismiss_email_popup'
const EXPIRE_TIME = 60 * 60 * 24 * 7 // set cookie expire time to 7 days

const OPEN_CLASS = 'open'

class Modal extends DynamicSectionElement {
  openModal(id) {
    const { disableScroll } = this.dataset
    const modalEl = document.querySelector(`#${id}`)
    if (!modalEl.classList.contains(OPEN_CLASS)) {
      modalEl.classList.add(OPEN_CLASS)
      if (disableScroll && disableScroll !== 'false') {
        document.documentElement.classList.add('overflow-hidden')
        document.body.classList.add('overflow-hidden')
        // disableBodyScroll()
      }
    }
  }

  closeModal(id) {
    const { disableScroll } = this.dataset
    const modalEl = document.querySelector(`#${id}`)
    modalEl.classList.remove(OPEN_CLASS)
    if (disableScroll && disableScroll !== 'false') {
      document.documentElement.classList.remove('overflow-hidden')
      document.body.classList.remove('overflow-hidden')
      clearAllBodyScrollLocks()
    }

    if (id === 'email-popup') {
      const newCookieValue = true
      Cookies.set(COOKIE_NAME, newCookieValue, { expires: EXPIRE_TIME })
    }
  }
}

// Use base DynamicSectionElement class to enable replacing of content loaded from Section Rendering API
customElements.define('shopify-modal', Modal)
